
export type CarSinisterType = 'GLASS' | 'WITH_CONTRARY' | 'WITHOUT_CONTRARY';

export interface CarSinisterReport {
  id: string;
  policyNumber: string;
  date: string;
  openDate: string;
  reportType: CarSinisterType;
}

export enum SinisterAutoType {
  WITH_CONTRARY= '020',
  WITHOUT_CONTRARY = '030',
  WITHOUT_CONTRARY_LEND = '040',
  ROAD_ASSISTANCE = '130',
  SAVED_SINISTER = '999'
}

export type CarSinisterRepairSchedulePreferenceType = 'M' | 'T' | 'I';

export enum SinisterAutoErrorType {
  SERVICE_GENERAL_ERROR = 'SERVICE_GENERAL_ERROR',
  SINISTER_NOT_AVAILABLE = 'SINISTER_NOT_AVAILABLE',
  POLICY_NOT_ACTIVE = 'POLICY_NOT_ACTIVE',
  PHONE_NOT_VALID = 'PHONE_NOT_VALID',
  SINISTER_WITH_THIRD_NOT_COVERED = 'SINISTER_WITH_THIRD_NOT_COVERED',
  SINISTER_WITHOUT_THIRD_NOT_COVERED = 'SINISTER_WITHOUT_THIRD_NOT_COVERED',
  WINDSHIELD_NOT_COVERED = 'WINDSHIELD_NOT_COVERED'
}

export enum SinisterAutoServiceError {
  SERVICE_GENERAL_ERROR = 'CLIENTS_AREA.CAR_SINISTERS.SERVICE_GENERAL_ERROR',
  SINISTER_NOT_AVAILABLE = 'CLIENTS_AREA.CAR_SINISTERS.SINISTER_NOT_AVAILABLE',
  POLICY_NOT_ACTIVE = 'CLIENTS_AREA.CAR_SINISTERS.POLICY_NOT_ACTIVE',
  PHONE_NOT_VALID = 'CLIENTS_AREA.CAR_SINISTERS.PHONE_NOT_VALID'
}
